import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useIsInBottomSheet } from '../BottomSheet';
import { useDevice } from '../Device';
import { BaseRichTextEditor } from './BaseRichTextEditor';
import { MobileRichTextEditor } from './MobileRichTextEditor';
export { extractPureTextFromRichText, applyValueToQuill, theme } from './BaseRichTextEditor';
export function RichTextEditor(props) {
    const { mobile } = props, restProps = _object_without_properties(props, [
        "mobile"
    ]);
    const { isMobileDevice } = useDevice();
    const isInBottomSheet = useIsInBottomSheet();
    if ((mobile === null || mobile === void 0 ? void 0 : mobile.renderAsCard) && isMobileDevice && !isInBottomSheet) {
        return /*#__PURE__*/ _jsx(MobileRichTextEditor, _object_spread({}, props));
    }
    return /*#__PURE__*/ _jsx(BaseRichTextEditor, _object_spread({}, restProps));
}
